const o = {
  "add-phone": {
    componentName: "WIconAddPhone",
    iconName: "add-phone",
    iconCategory: "action"
  },
  "add-visit": {
    componentName: "WIconAddVisit",
    iconName: "add-visit",
    iconCategory: "action"
  },
  "ai-phone": {
    componentName: "WIconAiPhone",
    iconName: "ai-phone",
    iconCategory: "action"
  },
  "alarm-clock": {
    componentName: "WIconAlarmClock",
    iconName: "alarm-clock",
    iconCategory: "action"
  },
  alarm: {
    componentName: "WIconAlarm",
    iconName: "alarm",
    iconCategory: "action"
  },
  back: {
    componentName: "WIconBack",
    iconName: "back",
    iconCategory: "action"
  },
  bin: { componentName: "WIconBin", iconName: "bin", iconCategory: "action" },
  bookmark: {
    componentName: "WIconBookmark",
    iconName: "bookmark",
    iconCategory: "action"
  },
  "calendar-block": {
    componentName: "WIconCalendarBlock",
    iconName: "calendar-block",
    iconCategory: "action"
  },
  "calendar-filled": {
    componentName: "WIconCalendarFilled",
    iconName: "calendar-filled",
    iconCategory: "action"
  },
  "calendar-off-patients": {
    componentName: "WIconCalendarOffPatients",
    iconName: "calendar-off-patients",
    iconCategory: "action"
  },
  "calendar-off": {
    componentName: "WIconCalendarOff",
    iconName: "calendar-off",
    iconCategory: "action"
  },
  "calendar-settings": {
    componentName: "WIconCalendarSettings",
    iconName: "calendar-settings",
    iconCategory: "action"
  },
  "calendar-share": {
    componentName: "WIconCalendarShare",
    iconName: "calendar-share",
    iconCategory: "action"
  },
  "calendar-with-check": {
    componentName: "WIconCalendarWithCheck",
    iconName: "calendar-with-check",
    iconCategory: "action"
  },
  calendar: {
    componentName: "WIconCalendar",
    iconName: "calendar",
    iconCategory: "action"
  },
  "check-filled": {
    componentName: "WIconCheckFilled",
    iconName: "check-filled",
    iconCategory: "action"
  },
  check: {
    componentName: "WIconCheck",
    iconName: "check",
    iconCategory: "action"
  },
  click: {
    componentName: "WIconClick",
    iconName: "click",
    iconCategory: "action"
  },
  "clock-filled": {
    componentName: "WIconClockFilled",
    iconName: "clock-filled",
    iconCategory: "action"
  },
  clock: {
    componentName: "WIconClock",
    iconName: "clock",
    iconCategory: "action"
  },
  "close-circle": {
    componentName: "WIconCloseCircle",
    iconName: "close-circle",
    iconCategory: "action"
  },
  "close-full": {
    componentName: "WIconCloseFull",
    iconName: "close-full",
    iconCategory: "action"
  },
  close: {
    componentName: "WIconClose",
    iconName: "close",
    iconCategory: "action"
  },
  copy: {
    componentName: "WIconCopy",
    iconName: "copy",
    iconCategory: "action"
  },
  cut: { componentName: "WIconCut", iconName: "cut", iconCategory: "action" },
  "dot-menu": {
    componentName: "WIconDotMenu",
    iconName: "dot-menu",
    iconCategory: "action"
  },
  "double-check-filled": {
    componentName: "WIconDoubleCheckFilled",
    iconName: "double-check-filled",
    iconCategory: "action"
  },
  "double-check": {
    componentName: "WIconDoubleCheck",
    iconName: "double-check",
    iconCategory: "action"
  },
  download: {
    componentName: "WIconDownload",
    iconName: "download",
    iconCategory: "action"
  },
  drag: {
    componentName: "WIconDrag",
    iconName: "drag",
    iconCategory: "action"
  },
  "end-call": {
    componentName: "WIconEndCall",
    iconName: "end-call",
    iconCategory: "action"
  },
  enlarge: {
    componentName: "WIconEnlarge",
    iconName: "enlarge",
    iconCategory: "action"
  },
  filters: {
    componentName: "WIconFilters",
    iconName: "filters",
    iconCategory: "action"
  },
  hamburger: {
    componentName: "WIconHamburger",
    iconName: "hamburger",
    iconCategory: "action"
  },
  hellip: {
    componentName: "WIconHellip",
    iconName: "hellip",
    iconCategory: "action"
  },
  hide: {
    componentName: "WIconHide",
    iconName: "hide",
    iconCategory: "action"
  },
  "in-progress": {
    componentName: "WIconInProgress",
    iconName: "in-progress",
    iconCategory: "action"
  },
  info: {
    componentName: "WIconInfo",
    iconName: "info",
    iconCategory: "action"
  },
  "letter-notification": {
    componentName: "WIconLetterNotification",
    iconName: "letter-notification",
    iconCategory: "action"
  },
  lock: {
    componentName: "WIconLock",
    iconName: "lock",
    iconCategory: "action"
  },
  logout: {
    componentName: "WIconLogout",
    iconName: "logout",
    iconCategory: "action"
  },
  "magnifier-less": {
    componentName: "WIconMagnifierLess",
    iconName: "magnifier-less",
    iconCategory: "action"
  },
  "magnifier-plus": {
    componentName: "WIconMagnifierPlus",
    iconName: "magnifier-plus",
    iconCategory: "action"
  },
  minimalize: {
    componentName: "WIconMinimalize",
    iconName: "minimalize",
    iconCategory: "action"
  },
  "minus-circle": {
    componentName: "WIconMinusCircle",
    iconName: "minus-circle",
    iconCategory: "action"
  },
  minus: {
    componentName: "WIconMinus",
    iconName: "minus",
    iconCategory: "action"
  },
  "move-visit": {
    componentName: "WIconMoveVisit",
    iconName: "move-visit",
    iconCategory: "action"
  },
  "negative-filled": {
    componentName: "WIconNegativeFilled",
    iconName: "negative-filled",
    iconCategory: "action"
  },
  notifications: {
    componentName: "WIconNotifications",
    iconName: "notifications",
    iconCategory: "action"
  },
  ongoing: {
    componentName: "WIconOngoing",
    iconName: "ongoing",
    iconCategory: "action"
  },
  "open-in-full": {
    componentName: "WIconOpenInFull",
    iconName: "open-in-full",
    iconCategory: "action"
  },
  out: { componentName: "WIconOut", iconName: "out", iconCategory: "action" },
  "paper-plane": {
    componentName: "WIconPaperPlane",
    iconName: "paper-plane",
    iconCategory: "action"
  },
  pen: { componentName: "WIconPen", iconName: "pen", iconCategory: "action" },
  pending: {
    componentName: "WIconPending",
    iconName: "pending",
    iconCategory: "action"
  },
  "phone-call": {
    componentName: "WIconPhoneCall",
    iconName: "phone-call",
    iconCategory: "action"
  },
  phone: {
    componentName: "WIconPhone",
    iconName: "phone",
    iconCategory: "action"
  },
  "plus-circle": {
    componentName: "WIconPlusCircle",
    iconName: "plus-circle",
    iconCategory: "action"
  },
  "plus-filled": {
    componentName: "WIconPlusFilled",
    iconName: "plus-filled",
    iconCategory: "action"
  },
  plus: {
    componentName: "WIconPlus",
    iconName: "plus",
    iconCategory: "action"
  },
  protect: {
    componentName: "WIconProtect",
    iconName: "protect",
    iconCategory: "action"
  },
  "question-filled": {
    componentName: "WIconQuestionFilled",
    iconName: "question-filled",
    iconCategory: "action"
  },
  question: {
    componentName: "WIconQuestion",
    iconName: "question",
    iconCategory: "action"
  },
  "refresh-filled": {
    componentName: "WIconRefreshFilled",
    iconName: "refresh-filled",
    iconCategory: "action"
  },
  refresh: {
    componentName: "WIconRefresh",
    iconName: "refresh",
    iconCategory: "action"
  },
  reorder: {
    componentName: "WIconReorder",
    iconName: "reorder",
    iconCategory: "action"
  },
  repeat: {
    componentName: "WIconRepeat",
    iconName: "repeat",
    iconCategory: "action"
  },
  reply: {
    componentName: "WIconReply",
    iconName: "reply",
    iconCategory: "action"
  },
  revert: {
    componentName: "WIconRevert",
    iconName: "revert",
    iconCategory: "action"
  },
  "sand-clock": {
    componentName: "WIconSandClock",
    iconName: "sand-clock",
    iconCategory: "action"
  },
  search: {
    componentName: "WIconSearch",
    iconName: "search",
    iconCategory: "action"
  },
  settings: {
    componentName: "WIconSettings",
    iconName: "settings",
    iconCategory: "action"
  },
  share: {
    componentName: "WIconShare",
    iconName: "share",
    iconCategory: "action"
  },
  shield: {
    componentName: "WIconShield",
    iconName: "shield",
    iconCategory: "action"
  },
  show: {
    componentName: "WIconShow",
    iconName: "show",
    iconCategory: "action"
  },
  "sort-ascending": {
    componentName: "WIconSortAscending",
    iconName: "sort-ascending",
    iconCategory: "action"
  },
  "sort-descending": {
    componentName: "WIconSortDescending",
    iconName: "sort-descending",
    iconCategory: "action"
  },
  "speed-gauge": {
    componentName: "WIconSpeedGauge",
    iconName: "speed-gauge",
    iconCategory: "action"
  },
  "sync-disabled": {
    componentName: "WIconSyncDisabled",
    iconName: "sync-disabled",
    iconCategory: "action"
  },
  "sync-problem": {
    componentName: "WIconSyncProblem",
    iconName: "sync-problem",
    iconCategory: "action"
  },
  "sync-success": {
    componentName: "WIconSyncSuccess",
    iconName: "sync-success",
    iconCategory: "action"
  },
  sync: {
    componentName: "WIconSync",
    iconName: "sync",
    iconCategory: "action"
  },
  unfold: {
    componentName: "WIconUnfold",
    iconName: "unfold",
    iconCategory: "action"
  },
  upload: {
    componentName: "WIconUpload",
    iconName: "upload",
    iconCategory: "action"
  },
  "vertical-lines": {
    componentName: "WIconVerticalLines",
    iconName: "vertical-lines",
    iconCategory: "action"
  },
  "view-agenda": {
    componentName: "WIconViewAgenda",
    iconName: "view-agenda",
    iconCategory: "action"
  },
  "view-day": {
    componentName: "WIconViewDay",
    iconName: "view-day",
    iconCategory: "action"
  },
  "view-three-days": {
    componentName: "WIconViewThreeDays",
    iconName: "view-three-days",
    iconCategory: "action"
  },
  "view-week": {
    componentName: "WIconViewWeek",
    iconName: "view-week",
    iconCategory: "action"
  },
  warning: {
    componentName: "WIconWarning",
    iconName: "warning",
    iconCategory: "action"
  },
  "arrow-down": {
    componentName: "WIconArrowDown",
    iconName: "arrow-down",
    iconCategory: "arrow"
  },
  "arrow-left": {
    componentName: "WIconArrowLeft",
    iconName: "arrow-left",
    iconCategory: "arrow"
  },
  "arrow-right": {
    componentName: "WIconArrowRight",
    iconName: "arrow-right",
    iconCategory: "arrow"
  },
  "arrow-up": {
    componentName: "WIconArrowUp",
    iconName: "arrow-up",
    iconCategory: "arrow"
  },
  "caret-left": {
    componentName: "WIconCaretLeft",
    iconName: "caret-left",
    iconCategory: "caret"
  },
  "caret-right": {
    componentName: "WIconCaretRight",
    iconName: "caret-right",
    iconCategory: "caret"
  },
  "caret-top": {
    componentName: "WIconCaretTop",
    iconName: "caret-top",
    iconCategory: "caret"
  },
  caret: {
    componentName: "WIconCaret",
    iconName: "caret",
    iconCategory: "caret"
  },
  "add-document": {
    componentName: "WIconAddDocument",
    iconName: "add-document",
    iconCategory: "content"
  },
  "book-open": {
    componentName: "WIconBookOpen",
    iconName: "book-open",
    iconCategory: "content"
  },
  "bubble-chat-filled": {
    componentName: "WIconBubbleChatFilled",
    iconName: "bubble-chat-filled",
    iconCategory: "content"
  },
  "bubble-chat-text": {
    componentName: "WIconBubbleChatText",
    iconName: "bubble-chat-text",
    iconCategory: "content"
  },
  "bubble-chat-texting": {
    componentName: "WIconBubbleChatTexting",
    iconName: "bubble-chat-texting",
    iconCategory: "content"
  },
  "bubble-chat": {
    componentName: "WIconBubbleChat",
    iconName: "bubble-chat",
    iconCategory: "content"
  },
  "bubble-q-and-a": {
    componentName: "WIconBubbleQAndA",
    iconName: "bubble-q-and-a",
    iconCategory: "content"
  },
  chart: {
    componentName: "WIconChart",
    iconName: "chart",
    iconCategory: "content"
  },
  "chat-outline": {
    componentName: "WIconChatOutline",
    iconName: "chat-outline",
    iconCategory: "content"
  },
  checklist: {
    componentName: "WIconChecklist",
    iconName: "checklist",
    iconCategory: "content"
  },
  clip: {
    componentName: "WIconClip",
    iconName: "clip",
    iconCategory: "content"
  },
  clipboard: {
    componentName: "WIconClipboard",
    iconName: "clipboard",
    iconCategory: "content"
  },
  diagnosis: {
    componentName: "WIconDiagnosis",
    iconName: "diagnosis",
    iconCategory: "content"
  },
  documents: {
    componentName: "WIconDocuments",
    iconName: "documents",
    iconCategory: "content"
  },
  excel: {
    componentName: "WIconExcel",
    iconName: "excel",
    iconCategory: "content"
  },
  "file-badge": {
    componentName: "WIconFileBadge",
    iconName: "file-badge",
    iconCategory: "content"
  },
  "file-image": {
    componentName: "WIconFileImage",
    iconName: "file-image",
    iconCategory: "content"
  },
  "file-pdf": {
    componentName: "WIconFilePdf",
    iconName: "file-pdf",
    iconCategory: "content"
  },
  "file-text": {
    componentName: "WIconFileText",
    iconName: "file-text",
    iconCategory: "content"
  },
  file: {
    componentName: "WIconFile",
    iconName: "file",
    iconCategory: "content"
  },
  identifier: {
    componentName: "WIconIdentifier",
    iconName: "identifier",
    iconCategory: "content"
  },
  invoice: {
    componentName: "WIconInvoice",
    iconName: "invoice",
    iconCategory: "content"
  },
  layers: {
    componentName: "WIconLayers",
    iconName: "layers",
    iconCategory: "content"
  },
  leads: {
    componentName: "WIconLeads",
    iconName: "leads",
    iconCategory: "content"
  },
  "list-bullets": {
    componentName: "WIconListBullets",
    iconName: "list-bullets",
    iconCategory: "content"
  },
  "mail-filled": {
    componentName: "WIconMailFilled",
    iconName: "mail-filled",
    iconCategory: "content"
  },
  mail: {
    componentName: "WIconMail",
    iconName: "mail",
    iconCategory: "content"
  },
  "no-image": {
    componentName: "WIconNoImage",
    iconName: "no-image",
    iconCategory: "content"
  },
  notes: {
    componentName: "WIconNotes",
    iconName: "notes",
    iconCategory: "content"
  },
  paper: {
    componentName: "WIconPaper",
    iconName: "paper",
    iconCategory: "content"
  },
  popular: {
    componentName: "WIconPopular",
    iconName: "popular",
    iconCategory: "content"
  },
  publication: {
    componentName: "WIconPublication",
    iconName: "publication",
    iconCategory: "content"
  },
  "quill-write": {
    componentName: "WIconQuillWrite",
    iconName: "quill-write",
    iconCategory: "content"
  },
  receipt: {
    componentName: "WIconReceipt",
    iconName: "receipt",
    iconCategory: "content"
  },
  reports: {
    componentName: "WIconReports",
    iconName: "reports",
    iconCategory: "content"
  },
  "request-quote": {
    componentName: "WIconRequestQuote",
    iconName: "request-quote",
    iconCategory: "content"
  },
  resume: {
    componentName: "WIconResume",
    iconName: "resume",
    iconCategory: "content"
  },
  treatment: {
    componentName: "WIconTreatment",
    iconName: "treatment",
    iconCategory: "content"
  },
  argentina: {
    componentName: "WIconArgentina",
    iconName: "argentina",
    iconCategory: "flags"
  },
  brazil: {
    componentName: "WIconBrazil",
    iconName: "brazil",
    iconCategory: "flags"
  },
  chile: {
    componentName: "WIconChile",
    iconName: "chile",
    iconCategory: "flags"
  },
  colombia: {
    componentName: "WIconColombia",
    iconName: "colombia",
    iconCategory: "flags"
  },
  "czech-republic": {
    componentName: "WIconCzechRepublic",
    iconName: "czech-republic",
    iconCategory: "flags"
  },
  germany: {
    componentName: "WIconGermany",
    iconName: "germany",
    iconCategory: "flags"
  },
  italy: {
    componentName: "WIconItaly",
    iconName: "italy",
    iconCategory: "flags"
  },
  mexico: {
    componentName: "WIconMexico",
    iconName: "mexico",
    iconCategory: "flags"
  },
  peru: { componentName: "WIconPeru", iconName: "peru", iconCategory: "flags" },
  poland: {
    componentName: "WIconPoland",
    iconName: "poland",
    iconCategory: "flags"
  },
  portugal: {
    componentName: "WIconPortugal",
    iconName: "portugal",
    iconCategory: "flags"
  },
  spain: {
    componentName: "WIconSpain",
    iconName: "spain",
    iconCategory: "flags"
  },
  turkey: {
    componentName: "WIconTurkey",
    iconName: "turkey",
    iconCategory: "flags"
  },
  amazed: {
    componentName: "WIconAmazed",
    iconName: "amazed",
    iconCategory: "human"
  },
  "assistive-technology": {
    componentName: "WIconAssistiveTechnology",
    iconName: "assistive-technology",
    iconCategory: "human"
  },
  bed: { componentName: "WIconBed", iconName: "bed", iconCategory: "human" },
  blind: {
    componentName: "WIconBlind",
    iconName: "blind",
    iconCategory: "human"
  },
  crutch: {
    componentName: "WIconCrutch",
    iconName: "crutch",
    iconCategory: "human"
  },
  deaf: { componentName: "WIconDeaf", iconName: "deaf", iconCategory: "human" },
  "disabled-access": {
    componentName: "WIconDisabledAccess",
    iconName: "disabled-access",
    iconCategory: "human"
  },
  disappointed: {
    componentName: "WIconDisappointed",
    iconName: "disappointed",
    iconCategory: "human"
  },
  diversity: {
    componentName: "WIconDiversity",
    iconName: "diversity",
    iconCategory: "human"
  },
  doctor: {
    componentName: "WIconDoctor",
    iconName: "doctor",
    iconCategory: "human"
  },
  "health-checkup": {
    componentName: "WIconHealthCheckup",
    iconName: "health-checkup",
    iconCategory: "human"
  },
  infant: {
    componentName: "WIconInfant",
    iconName: "infant",
    iconCategory: "human"
  },
  neutral: {
    componentName: "WIconNeutral",
    iconName: "neutral",
    iconCategory: "human"
  },
  patients: {
    componentName: "WIconPatients",
    iconName: "patients",
    iconCategory: "human"
  },
  people: {
    componentName: "WIconPeople",
    iconName: "people",
    iconCategory: "human"
  },
  pregnant: {
    componentName: "WIconPregnant",
    iconName: "pregnant",
    iconCategory: "human"
  },
  "public-q-and-a": {
    componentName: "WIconPublicQAndA",
    iconName: "public-q-and-a",
    iconCategory: "human"
  },
  "receive-cash": {
    componentName: "WIconReceiveCash",
    iconName: "receive-cash",
    iconCategory: "human"
  },
  sad: { componentName: "WIconSad", iconName: "sad", iconCategory: "human" },
  "smiling-face": {
    componentName: "WIconSmilingFace",
    iconName: "smiling-face",
    iconCategory: "human"
  },
  stethoscope: {
    componentName: "WIconStethoscope",
    iconName: "stethoscope",
    iconCategory: "human"
  },
  support: {
    componentName: "WIconSupport",
    iconName: "support",
    iconCategory: "human"
  },
  trust: {
    componentName: "WIconTrust",
    iconName: "trust",
    iconCategory: "human"
  },
  "user-filled": {
    componentName: "WIconUserFilled",
    iconName: "user-filled",
    iconCategory: "human"
  },
  user: { componentName: "WIconUser", iconName: "user", iconCategory: "human" },
  "web-accessibility": {
    componentName: "WIconWebAccessibility",
    iconName: "web-accessibility",
    iconCategory: "human"
  },
  clinic: {
    componentName: "WIconClinic",
    iconName: "clinic",
    iconCategory: "locations"
  },
  door: {
    componentName: "WIconDoor",
    iconName: "door",
    iconCategory: "locations"
  },
  facility: {
    componentName: "WIconFacility",
    iconName: "facility",
    iconCategory: "locations"
  },
  pharmacy: {
    componentName: "WIconPharmacy",
    iconName: "pharmacy",
    iconCategory: "locations"
  },
  "pin-bordered": {
    componentName: "WIconPinBordered",
    iconName: "pin-bordered",
    iconCategory: "locations"
  },
  pin: {
    componentName: "WIconPin",
    iconName: "pin",
    iconCategory: "locations"
  },
  "clinic-cloud": {
    componentName: "WIconClinicCloud",
    iconName: "clinic-cloud",
    iconCategory: "logos"
  },
  docplanner: {
    componentName: "WIconDocplanner",
    iconName: "docplanner",
    iconCategory: "logos"
  },
  gipo: { componentName: "WIconGipo", iconName: "gipo", iconCategory: "logos" },
  jameda: {
    componentName: "WIconJameda",
    iconName: "jameda",
    iconCategory: "logos"
  },
  "tuo-tempo": {
    componentName: "WIconTuoTempo",
    iconName: "tuo-tempo",
    iconCategory: "logos"
  },
  "camera-circle": {
    componentName: "WIconCameraCircle",
    iconName: "camera-circle",
    iconCategory: "media"
  },
  "camera-disabled": {
    componentName: "WIconCameraDisabled",
    iconName: "camera-disabled",
    iconCategory: "media"
  },
  "camera-switch": {
    componentName: "WIconCameraSwitch",
    iconName: "camera-switch",
    iconCategory: "media"
  },
  devices: {
    componentName: "WIconDevices",
    iconName: "devices",
    iconCategory: "media"
  },
  gallery: {
    componentName: "WIconGallery",
    iconName: "gallery",
    iconCategory: "media"
  },
  "magic-wand": {
    componentName: "WIconMagicWand",
    iconName: "magic-wand",
    iconCategory: "media"
  },
  megaphone: {
    componentName: "WIconMegaphone",
    iconName: "megaphone",
    iconCategory: "media"
  },
  "microphone-disabled": {
    componentName: "WIconMicrophoneDisabled",
    iconName: "microphone-disabled",
    iconCategory: "media"
  },
  microphone: {
    componentName: "WIconMicrophone",
    iconName: "microphone",
    iconCategory: "media"
  },
  "mobile-phone": {
    componentName: "WIconMobilePhone",
    iconName: "mobile-phone",
    iconCategory: "media"
  },
  "monitor-off": {
    componentName: "WIconMonitorOff",
    iconName: "monitor-off",
    iconCategory: "media"
  },
  monitor: {
    componentName: "WIconMonitor",
    iconName: "monitor",
    iconCategory: "media"
  },
  office: {
    componentName: "WIconOffice",
    iconName: "office",
    iconCategory: "media"
  },
  one: { componentName: "WIconOne", iconName: "one", iconCategory: "media" },
  "play-filled": {
    componentName: "WIconPlayFilled",
    iconName: "play-filled",
    iconCategory: "media"
  },
  play: { componentName: "WIconPlay", iconName: "play", iconCategory: "media" },
  "presentation-speech": {
    componentName: "WIconPresentationSpeech",
    iconName: "presentation-speech",
    iconCategory: "media"
  },
  print: {
    componentName: "WIconPrint",
    iconName: "print",
    iconCategory: "media"
  },
  "scan-wi-fi": {
    componentName: "WIconScanWiFi",
    iconName: "scan-wi-fi",
    iconCategory: "media"
  },
  screenshot: {
    componentName: "WIconScreenshot",
    iconName: "screenshot",
    iconCategory: "media"
  },
  tablet: {
    componentName: "WIconTablet",
    iconName: "tablet",
    iconCategory: "media"
  },
  text: { componentName: "WIconText", iconName: "text", iconCategory: "media" },
  "video-consultation": {
    componentName: "WIconVideoConsultation",
    iconName: "video-consultation",
    iconCategory: "media"
  },
  "view-grid": {
    componentName: "WIconViewGrid",
    iconName: "view-grid",
    iconCategory: "media"
  },
  "view-speaker": {
    componentName: "WIconViewSpeaker",
    iconName: "view-speaker",
    iconCategory: "media"
  },
  android: {
    componentName: "WIconAndroid",
    iconName: "android",
    iconCategory: "social"
  },
  "apple-color": {
    componentName: "WIconAppleColor",
    iconName: "apple-color",
    iconCategory: "social"
  },
  "facebook-circle-color": {
    componentName: "WIconFacebookCircleColor",
    iconName: "facebook-circle-color",
    iconCategory: "social"
  },
  "facebook-circle": {
    componentName: "WIconFacebookCircle",
    iconName: "facebook-circle",
    iconCategory: "social"
  },
  "glassdoor-circle": {
    componentName: "WIconGlassdoorCircle",
    iconName: "glassdoor-circle",
    iconCategory: "social"
  },
  "google-color": {
    componentName: "WIconGoogleColor",
    iconName: "google-color",
    iconCategory: "social"
  },
  google: {
    componentName: "WIconGoogle",
    iconName: "google",
    iconCategory: "social"
  },
  "instagram-circle": {
    componentName: "WIconInstagramCircle",
    iconName: "instagram-circle",
    iconCategory: "social"
  },
  "linkedin-circle": {
    componentName: "WIconLinkedinCircle",
    iconName: "linkedin-circle",
    iconCategory: "social"
  },
  messenger: {
    componentName: "WIconMessenger",
    iconName: "messenger",
    iconCategory: "social"
  },
  "social-connection": {
    componentName: "WIconSocialConnection",
    iconName: "social-connection",
    iconCategory: "social"
  },
  "spotify-circle": {
    componentName: "WIconSpotifyCircle",
    iconName: "spotify-circle",
    iconCategory: "social"
  },
  "thumb-down": {
    componentName: "WIconThumbDown",
    iconName: "thumb-down",
    iconCategory: "social"
  },
  "thumb-up": {
    componentName: "WIconThumbUp",
    iconName: "thumb-up",
    iconCategory: "social"
  },
  "twitter-circle": {
    componentName: "WIconTwitterCircle",
    iconName: "twitter-circle",
    iconCategory: "social"
  },
  whatsapp: {
    componentName: "WIconWhatsapp",
    iconName: "whatsapp",
    iconCategory: "social"
  },
  "youtube-circle": {
    componentName: "WIconYoutubeCircle",
    iconName: "youtube-circle",
    iconCategory: "social"
  },
  asterisk: {
    componentName: "WIconAsterisk",
    iconName: "asterisk",
    iconCategory: "symbols"
  },
  "badge-like": {
    componentName: "WIconBadgeLike",
    iconName: "badge-like",
    iconCategory: "symbols"
  },
  "bank-note": {
    componentName: "WIconBankNote",
    iconName: "bank-note",
    iconCategory: "symbols"
  },
  bulb: {
    componentName: "WIconBulb",
    iconName: "bulb",
    iconCategory: "symbols"
  },
  "circle-filled": {
    componentName: "WIconCircleFilled",
    iconName: "circle-filled",
    iconCategory: "symbols"
  },
  circle: {
    componentName: "WIconCircle",
    iconName: "circle",
    iconCategory: "symbols"
  },
  connected: {
    componentName: "WIconConnected",
    iconName: "connected",
    iconCategory: "symbols"
  },
  "credit-card": {
    componentName: "WIconCreditCard",
    iconName: "credit-card",
    iconCategory: "symbols"
  },
  dollar: {
    componentName: "WIconDollar",
    iconName: "dollar",
    iconCategory: "symbols"
  },
  euro: {
    componentName: "WIconEuro",
    iconName: "euro",
    iconCategory: "symbols"
  },
  "first-aid-plaster": {
    componentName: "WIconFirstAidPlaster",
    iconName: "first-aid-plaster",
    iconCategory: "symbols"
  },
  "gauntlet-gloves": {
    componentName: "WIconGauntletGloves",
    iconName: "gauntlet-gloves",
    iconCategory: "symbols"
  },
  globe: {
    componentName: "WIconGlobe",
    iconName: "globe",
    iconCategory: "symbols"
  },
  goal: {
    componentName: "WIconGoal",
    iconName: "goal",
    iconCategory: "symbols"
  },
  "hand-bag": {
    componentName: "WIconHandBag",
    iconName: "hand-bag",
    iconCategory: "symbols"
  },
  "hand-diamond": {
    componentName: "WIconHandDiamond",
    iconName: "hand-diamond",
    iconCategory: "symbols"
  },
  language: {
    componentName: "WIconLanguage",
    iconName: "language",
    iconCategory: "symbols"
  },
  microscope: {
    componentName: "WIconMicroscope",
    iconName: "microscope",
    iconCategory: "symbols"
  },
  parking: {
    componentName: "WIconParking",
    iconName: "parking",
    iconCategory: "symbols"
  },
  "payment-history": {
    componentName: "WIconPaymentHistory",
    iconName: "payment-history",
    iconCategory: "symbols"
  },
  pill: {
    componentName: "WIconPill",
    iconName: "pill",
    iconCategory: "symbols"
  },
  puzzle: {
    componentName: "WIconPuzzle",
    iconName: "puzzle",
    iconCategory: "symbols"
  },
  "qr-code": {
    componentName: "WIconQrCode",
    iconName: "qr-code",
    iconCategory: "symbols"
  },
  rectangle: {
    componentName: "WIconRectangle",
    iconName: "rectangle",
    iconCategory: "symbols"
  },
  "rounded-square-filled": {
    componentName: "WIconRoundedSquareFilled",
    iconName: "rounded-square-filled",
    iconCategory: "symbols"
  },
  "rounded-square": {
    componentName: "WIconRoundedSquare",
    iconName: "rounded-square",
    iconCategory: "symbols"
  },
  "saas-new-patient": {
    componentName: "WIconSaasNewPatient",
    iconName: "saas-new-patient",
    iconCategory: "symbols"
  },
  "school-graduation": {
    componentName: "WIconSchoolGraduation",
    iconName: "school-graduation",
    iconCategory: "symbols"
  },
  smart: {
    componentName: "WIconSmart",
    iconName: "smart",
    iconCategory: "symbols"
  },
  spinner: {
    componentName: "WIconSpinner",
    iconName: "spinner",
    iconCategory: "symbols"
  },
  thunder: {
    componentName: "WIconThunder",
    iconName: "thunder",
    iconCategory: "symbols"
  },
  tube: {
    componentName: "WIconTube",
    iconName: "tube",
    iconCategory: "symbols"
  },
  vaccine: {
    componentName: "WIconVaccine",
    iconName: "vaccine",
    iconCategory: "symbols"
  },
  "virtual-reality": {
    componentName: "WIconVirtualReality",
    iconName: "virtual-reality",
    iconCategory: "symbols"
  },
  virus: {
    componentName: "WIconVirus",
    iconName: "virus",
    iconCategory: "symbols"
  },
  wallet: {
    componentName: "WIconWallet",
    iconName: "wallet",
    iconCategory: "symbols"
  },
  zloty: {
    componentName: "WIconZloty",
    iconName: "zloty",
    iconCategory: "symbols"
  },
  dropdown: {
    componentName: "WIconDropdown",
    iconName: "dropdown",
    iconCategory: "toggle"
  },
  "empty-star-thin": {
    componentName: "WIconEmptyStarThin",
    iconName: "empty-star-thin",
    iconCategory: "toggle"
  },
  "empty-star": {
    componentName: "WIconEmptyStar",
    iconName: "empty-star",
    iconCategory: "toggle"
  },
  "flower-star": {
    componentName: "WIconFlowerStar",
    iconName: "flower-star",
    iconCategory: "toggle"
  },
  "half-heart": {
    componentName: "WIconHalfHeart",
    iconName: "half-heart",
    iconCategory: "toggle"
  },
  "half-star": {
    componentName: "WIconHalfStar",
    iconName: "half-star",
    iconCategory: "toggle"
  },
  "heart-filled": {
    componentName: "WIconHeartFilled",
    iconName: "heart-filled",
    iconCategory: "toggle"
  },
  heart: {
    componentName: "WIconHeart",
    iconName: "heart",
    iconCategory: "toggle"
  },
  "radio-button": {
    componentName: "WIconRadioButton",
    iconName: "radio-button",
    iconCategory: "toggle"
  },
  star: {
    componentName: "WIconStar",
    iconName: "star",
    iconCategory: "toggle"
  },
  "three-stars": {
    componentName: "WIconThreeStars",
    iconName: "three-stars",
    iconCategory: "toggle"
  }
};
export {
  o as default
};
